import React from 'react';
import styles from './Layout.module.scss';

const ContainerWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.containerWrapper}>{children}</div>;
};

export default ContainerWrapper;
